import { ID } from '@griply/types';

import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type DeleteExternalConnectionOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  id: ID;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  db: TDb;
};

export const deleteExternalConnection = async <
  TDocRef,
  TDb = FirestoreInstance,
>(
  options: DeleteExternalConnectionOptions<TDocRef, TDb>,
): Promise<void> => {
  const { id, doc, deleteDoc, db } = options;

  const ref = doc(db, FirestoreCollections.ExternalConnections, id);
  await deleteDoc(ref);
};
